import { base64ToArrayBuffer } from './base64ToArrayBuffer'
import { saveByteArray } from './saveByteArray'

export function byteArrayToPDF(fileName: string, data: any) {
  const array = base64ToArrayBuffer(data)
  saveByteArray(fileName, array)
}
